import { SelectedPlatform } from "./SelectPlatform";
export default SelectedPlatform;